window._ = require('lodash');

try {
    window.$ = window.jQuery = require('jquery');
    window.Vue = require('vue');

    require('popper.js');
    require('bootstrap');
    require('../../../../modules/system/assets/js/framework.js');
    require('../../../../modules/system/assets/js/framework.extras.js');
} catch (e) {}


// attach a csrf token to all of our xhr requests
import axios from 'axios';
axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name=token]').getAttribute('content');



// WEBPACK FOOTER //
// ./themes/ldc/assets/js/bootstrap.js